import { FC } from 'react';
import * as styles from './index.css';

interface Props extends React.HTMLAttributes<HTMLElement> {
  name: string;
  variant?: keyof typeof styles.variants;
  size?: keyof typeof styles.sizes;
  color?: keyof typeof styles.colors;
  fill?: boolean;
}

const Icon: FC<Props> = ({
  name,
  variant = 'rounded',
  size = 'md',
  color = 'inherit',
  fill = false,
  className,
  ...rest
}) => (
  <i
    {...rest}
    translate='no'
    aria-hidden={rest['aria-label'] ? undefined : true}
    className={[
      styles.variants[variant],
      styles.sizes[size],
      styles.colors[color],
      fill ? styles.fills.filled : styles.fills.outline,
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {name}
  </i>
);

export default Icon;
